import { CuentasOtrosBancosComponent } from '../components/asuntos-internos/investigacion/cuentas-otros-bancos/cuentas-otros-bancos.component';
import { DatosFiliatoriosComponent } from '../components/asuntos-internos/investigacion/datos-filiatorios/datos-filiatorios.component';
import { DatosMigratoriosComponent } from '../components/asuntos-internos/investigacion/datos-migratorios/datos-migratorios.component';
import { DatosResidencialesComponent } from '../components/asuntos-internos/investigacion/datos-residenciales/datos-residenciales.component';
import { DireccionAntecedentesLaboralesComponent } from '../components/asuntos-internos/investigacion/direccion-antecedentes-laborales/direccion-antecedentes-laborales.component';
import { EvaluacionPesquisaComponent } from '../components/asuntos-internos/investigacion/evaluacion-pesquisa/evaluacion-pesquisa.component';
import { InformacionEmpleadosComponent } from '../components/asuntos-internos/investigacion/informacion-empleados/informacion-empleados.component';
import { InteraccionRedesSocialesComponent } from '../components/asuntos-internos/investigacion/interaccion-redes-sociales/interaccion-redes-sociales.component';
import { OrigenAsignacionCasoInvestigacionComponent } from '../components/asuntos-internos/investigacion/origen-asignacion-caso-investigacion/origen-asignacion-caso-investigacion.component';
import { RastreoMovimientosBancariosComponent } from '../components/asuntos-internos/investigacion/rastreo-movimientos-bancarios/rastreo-movimientos-bancarios.component';
import { ReporteDelitosInformaticosComponent } from '../components/asuntos-internos/investigacion/reporte-delitos-informaticos/reporte-delitos-informaticos.component';
import { ConfirmarActividadIrregularComponent } from '../components/grupos-vip/confirmar-actividad-irregular/confirmar-actividad-irregular.component';
import { ContactoGerenteComponent } from '../components/grupos-vip/contacto-gerente/contacto-gerente.component';
import { EvaluacionInicialCasoComponent } from '../components/grupos-vip/evaluacion-inicial-caso/evaluacion-inicial-caso.component';

export const COMPONENTS = [
  {
    name: 'Registrar expediente',
    value: 'OrigenAsignacionCasoInvestigacion',
    component: OrigenAsignacionCasoInvestigacionComponent,
    caso: 'Investigación de asuntos internos',
  },
  {
    name: 'Evaluación de Pesquisa',
    value: 'evaluacionPesquisa',
    component: EvaluacionPesquisaComponent,
    caso: 'Investigación de asuntos internos',
  },
  {
    name: 'Perfil - Reporte de delitos informáticos del CICPC',
    value: 'ReporteDelitosInformaticos',
    component: ReporteDelitosInformaticosComponent,
    caso: 'Investigación de asuntos internos',
  },
  {
    name: 'Perfil - Datos migratorios (SAIME)',
    value: 'DatosMigratorios',
    component: DatosMigratoriosComponent,
    caso: 'Investigación de asuntos internos',
  },
  {
    name: 'Perfil - Datos residenciales (SENIAT-CNE)',
    value: 'DatosResidenciales',
    component: DatosResidencialesComponent,
    caso: 'Investigación de asuntos internos',
  },
  {
    name: 'Perfil - Dirección y antecedentes laborales (Seguro social)',
    value: 'DireccionAntecedentesLaborales',
    component: DireccionAntecedentesLaboralesComponent,
    caso: 'Investigación de asuntos internos',
  },
  {
    name: 'Perfil - Datos filiatorios (Perfil como cliente de banco)',
    value: 'DatosFiliatorios',
    component: DatosFiliatoriosComponent,
    caso: 'Investigación de asuntos internos',
  },
  {
    name: 'Información de empleados y directorio interno de la empresa (Peoplesoft - Direm)',
    value: 'InformacionEmpleados',
    component: InformacionEmpleadosComponent,
    caso: 'Investigación de asuntos internos',
  },
  {
    name: 'Perfil - Cuentas otros bancos',
    value: 'CuentasOtrosBancos',
    component: CuentasOtrosBancosComponent,
    caso: 'Investigación de asuntos internos',
  },
  {
    name: 'Perfil - Interacción de redes sociales',
    value: 'InteraccionRedesSociales',
    component: InteraccionRedesSocialesComponent,
    caso: 'Investigación de asuntos internos',
  },
  {
    name: 'Perfil - Rastreo de movimientos bancarios',
    value: 'RastreoMovimientosBancarios',
    component: RastreoMovimientosBancariosComponent,
    caso: 'Investigación de asuntos internos',
  },
  {
    name: 'Confirmar Actividad Irregular',
    value: 'ConfirmarActividadIrregular',
    component: ConfirmarActividadIrregularComponent,
    caso: 'Investigación de asuntos internos',
  },
  {
    name: 'Evaluación Inicial del Caso',
    value: 'EvaluacionInicialCaso',
    component: EvaluacionInicialCasoComponent,
    caso: 'Gestion de Casos VIP',
  },
  {
    name: 'Contacto con Gerente de Oficina',
    value: 'ContactoGerente',
    component: ContactoGerenteComponent,
    caso: 'Investigación de asuntos internos',
  },
];
